"use client"
import { useGlobalStore } from "@/store"
import { Component } from "@/types/types"
import { CaptchaLoader } from "@/ui/loaders/CaptchaLoader"
import { cx } from "@/utils/cx"
import { useEffect } from "react"

export interface Props extends Component {}

export function AuthWrapper({ className = "", children }: Props) {
  const store = useGlobalStore()
  useEffect(() => {
    store.update({ captchaVisible: true })
    return () => store.update({ captchaVisible: false })
  }, [])

  return (
    <>
      <div className={cx("text-text bg-background", className)}>{children}</div>
      <CaptchaLoader />
    </>
  )
}
